import React, {useState} from 'react'
import PropTypes from 'prop-types'
import CustomerFormModal from "./CustomerFormModal";
import EditIcon from "../../../../statics/assets/icons/edit-outlined.svg"

CustomerForm.propTypes = {
    item: PropTypes.object,
    type: PropTypes.string,
    label: PropTypes.string,
    createBy: PropTypes.string,
    text: PropTypes.string,
}

function CustomerForm(props) {
    const {item: itemProps, type, text = ''} = props
    const [isModalVisible, setIsModalVisible] = useState(false)

    const showModal = () => {
        setIsModalVisible(true)
    }

    return (
        <div className="CustomerForm">
            {
                type === 'edit' ?
                    text === 'name' ?
                        <span className="Content Link" onClick={showModal}>{itemProps?.name}</span>
                        : <span onClick={showModal} style={{cursor: 'pointer', display: 'inline-flex'}}><EditIcon width={18} height={18}/></span>
                    :
                    <button className="ButtonCustom" onClick={showModal}>
                        <span className="material-icons">add</span>
                        <span>Add new</span>
                    </button>
            }

            {isModalVisible &&
                <CustomerFormModal isModalVisible={isModalVisible} setIsModalVisible={setIsModalVisible} {...props}/>}
        </div>
    )
}

export default CustomerForm
